module.exports = __webpack_public_path__ + "img/9.85029c8c.png";